import { useTranslation } from "react-i18next";

const H = 44;
// Official artwork files; `box` = artwork bounds inside the file (transparent padding excluded), file units.
const STORES = [
  { k: "apple", url: (process.env.REACT_APP_APP_STORE_URL || "").trim(), alt: "b7.apple_alt",
    file: { en: ["/badges/apple-en-us.svg", 119.66407, 40, [0, 0, 119.66407, 40]], ru: ["/badges/apple-ru-ru.svg", 119.66407, 40, [0, 0, 119.66407, 40]] } },
  { k: "google", url: (process.env.REACT_APP_GOOGLE_PLAY_URL || "").trim(), alt: "b7.google_alt",
    file: { en: ["/badges/google-en.png", 646, 250, [41, 41, 605, 209]], ru: ["/badges/google-ru.png", 646, 250, [0, 29, 646, 221]] } },
];

function Badge({ s, lang, testid }) {
  const { t } = useTranslation();
  const [src, w, h, [x1, y1, x2, y2]] = s.file[lang];
  const k = H / (y2 - y1);
  const art = (
    <span className="relative block overflow-hidden" style={{ width: Math.round((x2 - x1) * k), height: H }}>
      <img src={src} alt={t(s.alt)} draggable={false} decoding="async" data-testid={`${testid}-img`}
        style={{ position: "absolute", left: -x1 * k, top: -y1 * k, width: w * k, height: h * k, maxWidth: "none" }} />
    </span>
  );
  return (
    <li data-testid={testid} data-store={s.k} data-live={s.url ? "1" : "0"}>
      {s.url ? <a href={s.url} target="_blank" rel="noopener noreferrer" className="block rounded-lg">{art}</a> : art}
    </li>
  );
}

export function AppBadges({ testid = "app-badges", className = "" }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ru") ? "ru" : "en";
  const pending = STORES.some((s) => !s.url);
  return (
    <div data-testid={testid} className={`flex flex-wrap items-center gap-3 ${className}`}>
      <ul className="flex flex-wrap items-center gap-3" aria-label={t("b7.apps")}>
        {STORES.map((s) => <Badge key={s.k} s={s} lang={lang} testid={`${testid}-${s.k}`} />)}
      </ul>
      {pending && <span data-testid={`${testid}-soon`} className="inline-flex h-control items-center rounded-full border border-dashed border-ink/40 bg-card px-4 text-sm font-semibold text-ink">{t("b7.soon")}</span>}
    </div>
  );
}
